import React from 'react'
import styled from 'styled-components'
import Router from 'next/router'
import { EmailValidationTemplate } from '@olxbr/accounts-web-components'
import { getQS } from '../../util/uri'
import { LoadingBackdrop } from '../../components/LoadingBackdrop'
import { Footer } from "@olxbr/olx-components";
import { Header } from '../../components/Header';

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 32px;
  margin-bottom: 64px;
`

class EmailValidation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      token: undefined,
      isLoading: true,
    }
  }

  componentDidMount() {
    const token = getQS('token')
    this.setState({ token })
  }

  stopLoading = () => {
    this.setState({ isLoading: false })
  }

  onMyAccountClick = () => {
    this.setState({ isLoading: true }, () => {
      Router.push('https://conta.olx.com.br/meu-cadastro')
    })
  }

  render() {
    const { isLoading, token } = this.state

    return (
      <React.Fragment>
        <Header />
        <Content>
          {isLoading && <LoadingBackdrop />}
          {!!token &&
            <EmailValidationTemplate
              token={token}
              onMyAccountClick={this.onMyAccountClick}
              onSuccess={this.stopLoading}
              onExpiredLink={this.stopLoading}
            />
          }
        </Content>
        <Footer />
      </React.Fragment>
    )
  }
}

export default EmailValidation
